module.exports = __webpack_public_path__ + "static/img/tech4.c17817b6.png";